import { cookieNames, FunnelJourney, setCookie } from '../cookie-utils';
import { createStore } from 'zustand/vanilla';
import { createBoundedUseStore } from 'common-functions';
import { applyUnifiedBagsSuffixConditionally } from '../unified-bags-funnel-journey-utils';

type FunnelJourneyData = { value?: FunnelJourney; setValue: (value: FunnelJourney) => void };

/**
 * TODO: CDT-4482 - Remove after unified bags rollout
 * Revert by using `value` directly instead of `updatedValue` for state, localStorage, and cookie
 */
export const funnelJourneyStore = createStore<FunnelJourneyData>(set => ({
  setValue: (value: FunnelJourney) => {
    const journeyToSet = applyUnifiedBagsSuffixConditionally(value.FunnelJourney);
    const updatedValue = { ...value, FunnelJourney: journeyToSet };

    set(state => ({ ...state, value: updatedValue }));
    const funnelJourneyKey = cookieNames.localStorage.journey;
    localStorage.setItem(funnelJourneyKey, JSON.stringify({ expiration: null, value: updatedValue }));

    if (journeyToSet) {
      setCookie(cookieNames.Availability.ejJourney, journeyToSet, {
        path: '/',
        sameSite: 'Lax',
        secure: true,
        domain: cookieNames.Availability.ejJourneyDomain
      });
    }
  }
}));
export const useFunnelJourneyStore = createBoundedUseStore(funnelJourneyStore);
